import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Linkedin, ArrowLeft, CalendarDays } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function ContactPage() {
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-170">
      {/* Navigation */}
      <nav className="border-b border-gray-100 bg-white/80 backdrop-blur-md sticky top-0 z-50" data-id="element-171">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-172">
          <Link to="/" className="text-xl font-bold text-gray-900" data-id="element-173">
            Vivin Varghese
          </Link>
          <div className="flex items-center gap-4" data-id="element-174">
            <Link to="/" className="text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-175">
              Home
            </Link>
            <Link to="/book" data-id="element-176">
              <Button size="sm" data-id="element-177">Book Meeting</Button>
            </Link>
          </div>
        </div>
      </nav>

      <main className="flex-grow py-12 px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="max-w-3xl mx-auto space-y-8" data-id="element-179">
          <div className="text-center space-y-4" data-id="element-180">
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-181">Get in Touch</h1>
            <p className="text-xl text-gray-600" data-id="element-182">
              I'm always open to discussing new projects, creative ideas, or
              opportunities to be part of your visions.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-183">
            {/* Personal Contact Info */}
            <Card className="p-6 space-y-6 md:col-span-2" data-id="element-184">
              <h2 className="text-lg font-semibold text-gray-900 border-b border-gray-100 pb-4" data-id="element-185">
                Contact Information
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-186">
                <a href="mailto:vivin14@icloud.com" className="flex items-start gap-4 p-4 rounded-lg hover:bg-gray-50 transition-colors group" data-id="element-187">
                  <div className="bg-blue-100 p-3 rounded-full group-hover:bg-blue-200 transition-colors" data-id="element-188">
                    <Mail className="w-6 h-6 text-blue-600" data-id="element-189" />
                  </div>
                  <div data-id="element-190">
                    <p className="font-medium text-gray-900" data-id="element-191">Email</p>
                    <p className="text-gray-600 break-all" data-id="element-192">
                      vivin14@icloud.com
                    </p>
                  </div>
                </a>

                <a href="tel:+917207453446" className="flex items-start gap-4 p-4 rounded-lg hover:bg-gray-50 transition-colors group" data-id="element-193">
                  <div className="bg-blue-100 p-3 rounded-full group-hover:bg-blue-200 transition-colors" data-id="element-194">
                    <Phone className="w-6 h-6 text-blue-600" data-id="element-195" />
                  </div>
                  <div data-id="element-196">
                    <p className="font-medium text-gray-900" data-id="element-197">Phone</p>
                    <p className="text-gray-600" data-id="element-198">+91 72074 53446</p>
                  </div>
                </a>

                <a href="https://www.linkedin.com/in/14vivin/" target="_blank" rel="noopener noreferrer" className="flex items-start gap-4 p-4 rounded-lg hover:bg-gray-50 transition-colors group md:col-span-2" data-id="element-199">
                  <div className="bg-blue-100 p-3 rounded-full group-hover:bg-blue-200 transition-colors" data-id="element-200">
                    <Linkedin className="w-6 h-6 text-blue-600" data-id="element-201" />
                  </div>
                  <div data-id="element-202">
                    <p className="font-medium text-gray-900" data-id="element-203">LinkedIn</p>
                    <p className="text-gray-600" data-id="element-204">linkedin.com/in/14vivin</p>
                  </div>
                </a>
              </div>
            </Card>

            {/* PTC Event Note */}
            <Card className="p-6 bg-blue-50 border-blue-100 md:col-span-2" data-id="element-205">
              <div className="flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left" data-id="element-206">
                <div className="bg-white p-4 rounded-full shadow-sm" data-id="element-207">
                  <CalendarDays className="w-8 h-8 text-blue-600" data-id="element-208" />
                </div>
                <div className="flex-grow space-y-2" data-id="element-209">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-210">
                    Attending PTC Event 2026?
                  </h3>
                  <p className="text-gray-600" data-id="element-211">
                    If you'd like to schedule a meeting during the event, please
                    use the dedicated booking system.
                  </p>
                </div>
                <Link to="/book" className="flex-shrink-0" data-id="element-212">
                  <Button data-id="element-213">Schedule Meeting</Button>
                </Link>
              </div>
            </Card>
          </div>
        </div>
      </main>

      <footer className="bg-white border-t border-gray-200 py-8" data-id="element-214">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-gray-500 text-sm" data-id="element-215">
          <p data-id="element-216">
            © {new Date().getFullYear()} Vivin Varghese. All rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}